import { render, staticRenderFns } from "./HotsiteConfigurationAdvanced.vue?vue&type=template&id=b96da94a&scoped=true"
import script from "./HotsiteConfigurationAdvanced.vue?vue&type=script&lang=js"
export * from "./HotsiteConfigurationAdvanced.vue?vue&type=script&lang=js"
import style0 from "./HotsiteConfigurationAdvanced.vue?vue&type=style&index=0&id=b96da94a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96da94a",
  null
  
)

export default component.exports